var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ENG_Flag",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M40.646,18.381H30.119A11.75,11.75,0,0,0,18.382,30.117V40.645A11.75,11.75,0,0,0,30.119,52.381H40.646A11.749,11.749,0,0,0,52.382,40.645V30.117A11.749,11.749,0,0,0,40.646,18.381Z",
    transform: "translate(-18.382 -18.381)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M52.38,32.328v6.1H38.432V52.38h-6.1V38.432H18.38v-6.1H32.328V18.38h6.1V32.328Z",
    transform: "translate(-18.38 -18.38)",
    fill: "#d90028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M334.077,332.477a12.418,12.418,0,0,1-1.6,1.6l-8.317-8.317v-1.6h1.6Z",
    transform: "translate(-302.942 -302.942)",
    fill: "#d90028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M66.277,64.687v1.6h-1.6L56.36,57.969a12.421,12.421,0,0,1,1.6-1.6Z",
    transform: "translate(-53.495 -53.504)",
    fill: "#d90028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M334.078,57.951l-8.318,8.317h-1.6v-1.6l8.317-8.318A12.535,12.535,0,0,1,334.078,57.951Z",
    transform: "translate(-302.942 -53.486)",
    fill: "#d90028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M66.277,324.16v1.6l-8.317,8.317a12.471,12.471,0,0,1-1.6-1.6l8.317-8.317Z",
    transform: "translate(-53.495 -302.942)",
    fill: "#d90028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M20.092,99.335a12.3,12.3,0,0,0-1.709,6.267v.409h8.468Z",
    transform: "translate(-18.383 -93.615)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M18.383,324.156v.409a12.3,12.3,0,0,0,1.707,6.263l6.759-6.672Z",
    transform: "translate(-18.383 -302.552)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M388.089,330.836a12.3,12.3,0,0,0,1.711-6.271v-.409h-8.47Z",
    transform: "translate(-355.8 -302.552)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M389.845,106.054v-.409a12.3,12.3,0,0,0-1.706-6.263l-6.76,6.673Z",
    transform: "translate(-355.845 -93.659)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M324.156,26.847l6.673-6.759a12.3,12.3,0,0,0-6.263-1.706h-.409Z",
    transform: "translate(-302.552 -18.381)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M106.058,381.38l-6.672,6.759a12.3,12.3,0,0,0,6.265,1.707h.408Z",
    transform: "translate(-93.662 -355.846)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M324.157,381.329v8.47h.409a12.3,12.3,0,0,0,6.271-1.711Z",
    transform: "translate(-302.553 -355.799)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M106.011,26.849V18.381H105.6a12.3,12.3,0,0,0-6.268,1.709Z",
    transform: "translate(-93.615 -18.381)",
    fill: "#0153b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M18.424,40.6V30.122c0-6.458,5.544-11.7,12.376-11.7h4.3c-3.365.639-12.452,3.109-13.829,11.013L21.2,42.327s.331,5.254,2.791,8.049A11.552,11.552,0,0,1,18.424,40.6Z",
    transform: "translate(-18.421 -18.419)",
    fill: "#fff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M153.339,30.16V40.677a11.648,11.648,0,0,1-11.548,11.738H131.444a11.41,11.41,0,0,1-3.865-.677l10.43-.907c10.775-1.511,11.191-8.909,11.191-8.909l-.048-12.85s-.226-7.555-9.181-10.65h1.82A11.648,11.648,0,0,1,153.339,30.16Z",
    transform: "translate(-119.342 -18.419)",
    fill: "#160204",
    opacity: 0.13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngFlag);
export default __webpack_public_path__ + "static/media/ENG_Flag.220d020a6a2c9bc529f13fcafa58f143.svg";
export { ForwardRef as ReactComponent };